import { CircleNotch, Plus } from '@phosphor-icons/react';

const SEED_BRANDS = [
  { key: 'georgia-boot', name: 'Georgia Boot', region: 'US', network: 'CJ #6284907', count: 12, blurb: 'Work / hiking boots — steel toe, waterproof, wedges' },
  { key: 'durango',      name: 'Durango Boots', region: 'US', network: 'CJ #6284905', count: 10, blurb: 'Western, mens & womens, work, kids' },
  { key: 'rocky-boots',  name: 'Rocky Boots',   region: 'US', network: 'CJ #6284903', count: 10, blurb: 'Hunting, tactical/duty, postal-approved' },
  { key: 'salomon',      name: 'Salomon UK',    region: 'UK', network: 'Awin #86257', count: 12, blurb: 'Trail running, road, hiking, winter boots' },
  { key: 'esska',        name: 'Esska Shoes',   region: 'UK', network: 'Awin #78134', count: 6,  blurb: 'Womens fashion — courts, loafers, sandals, Chelsea boots' },
  { key: 'cosyfeet',     name: 'Cosyfeet',      region: 'UK', network: 'Awin #100719', count: 8, blurb: 'Extra-wide / 6E-8E comfort footwear for swollen feet & bunions' },
];

/**
 * SeedTab — one-click seeders for approved affiliate brands.
 */
export default function SeedTab({ seedingKey, seedResults, onRunSeed }) {
  return (
    <div className="space-y-6" data-testid="seed-tab">
      <div className="border border-[#E4E4E7] bg-white p-6">
        <h3 className="font-heading font-bold text-lg mb-2">Seed Catalog</h3>
        <p className="text-sm text-[#52525B] mb-2">
          One-click bulk-insert affiliate brands into <strong>this database</strong>. Each seeder is idempotent — running it twice will update, not duplicate.
        </p>
        <div className="bg-[#FFF5F4] border border-[#FECACA] p-3 text-xs text-[#7C2D12] mb-6">
          <strong>Heads up:</strong> this seeds the database the backend is currently connected to. To seed your live production app, open the production Admin (after the latest deploy) and click the buttons there.
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {SEED_BRANDS.map(brand => {
            const result = seedResults[brand.key];
            const isRunning = seedingKey === brand.key;
            return (
              <div key={brand.key} className="border-2 border-[#E4E4E7] p-4 hover:border-[#0A0A0A] transition-colors" data-testid={`seed-card-${brand.key}`}>
                <div className="flex items-start justify-between gap-3 mb-2">
                  <div>
                    <p className="font-heading font-black text-base uppercase tracking-tight">{brand.name}</p>
                    <p className="text-[10px] font-bold uppercase tracking-wide text-[#52525B] mt-0.5">{brand.region} · {brand.network} · {brand.count} shoes</p>
                  </div>
                  {result?.status === 'ok' && <span className="text-[10px] font-bold uppercase bg-[#F0FDF4] text-[#10B981] px-2 py-1">Seeded</span>}
                  {result?.status === 'error' && <span className="text-[10px] font-bold uppercase bg-[#FFF5F4] text-[#FF3B30] px-2 py-1">Failed</span>}
                </div>
                <p className="text-xs text-[#52525B] mb-4">{brand.blurb}</p>
                <button
                  onClick={() => onRunSeed(brand.key)}
                  disabled={isRunning}
                  className="bg-[#FF3B30] text-white font-bold uppercase tracking-wide px-5 py-2.5 text-xs hover:bg-[#D62828] transition-colors disabled:opacity-50 flex items-center gap-2"
                  data-testid={`seed-btn-${brand.key}`}
                >
                  {isRunning ? <CircleNotch size={14} className="animate-spin" /> : <Plus size={14} weight="bold" />}
                  {isRunning ? 'Seeding...' : (result?.status === 'ok' ? 'Re-seed (idempotent)' : `Seed ${brand.name}`)}
                </button>
                {result?.status === 'ok' && (
                  <p className="text-[11px] text-[#10B981] font-bold mt-3" data-testid={`seed-ok-${brand.key}`}>OK · {result.at}</p>
                )}
                {result?.status === 'error' && (
                  <p className="text-[11px] text-[#FF3B30] font-bold mt-3 break-words" data-testid={`seed-err-${brand.key}`}>{result.detail}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
